<div class="pd40">

    <!-- Usuario nombre -->
    <div fxLayoutAlign=" center">
        <img [src]="usuario.photoURL" alt="foto de perfil" class="avatar4">
        <div class="mgl10">
            <h6 class="ft500 mgb0 mgt0">Bienvenido {{usuario.nombreCompleto}}</h6>
            <p class="mgb0 mgt0">{{token}}</p>
        </div>
    </div>

    <!-- Info de resumen -->
    <h6 class="mgt40 ft16 ft500 mgb20">Resumen</h6>

    <div fxLayout="row" fxLayoutGap="" class="border">
        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="border-r radius3 pd10">
            <h6 class="centertext default-font-color ft14"> Usuarios </h6>
            <p class="ftxl centertext mgb0 gray-9"> {{cantUsuarios}}</p>
        </div>

        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="border-r radius3 pd10">
            <h6 class="centertext default-font-color ft14"> Cursos </h6>
            <p class="ftxl centertext mgb0 gray-9"> {{cantCursos}}</p>
        </div>

        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="border-r radius3 pd10">
            <h6 class="centertext default-font-color ft14"> Instructores </h6>
            <p class="ftxl centertext mgb0 gray-9"> {{cantInstructores}}</p>
        </div>

        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" class="radius3 pd10">
            <h6 class="centertext default-font-color ft14"> Empresas </h6>
            <p class="ftxl centertext mgb0 gray-9"> {{cantEmpresas}}</p>
        </div>
        
    </div>
</div>